import type { PaymentMethod } from "features/paymentMethods/types";
import When from "ui/support/When";

const PaymentMethodValueTooltip = ({ merchantVisibleMethodCoreId }: PaymentMethod) => (
    <When
        if={!merchantVisibleMethodCoreId}
        then='Inactive — enable in payment methods'
        else='Temporarily unavailable — will be reactivated when service is restored'
    />
);

export default PaymentMethodValueTooltip;
